<h2 mat-dialog-title>Logout</h2>
<mat-dialog-content class="mat-typography">
  <p>Are you sure you want to logout?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button style="color: black;" mat-button mat-dialog-close>Cancel</button>
  <button style="color: black;" mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="logout()">Logout</button>
</mat-dialog-actions>
